import { createFileRoute, Navigate } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { ErrorEmptyState } from '@/components/ui/empty-state';
import { SkeletonForm } from '@/components/ui/skeleton';
import { useDealStateGate } from '@/features/analysis-setup/hooks/useDealStateGate';
import { SalesMethodologyStep } from '@/features/prompt-builder/components/SalesMethodologyStep';

export const Route = createFileRoute('/analysis-setup/sales-methodology')({
  component: AnalysisSetupSalesMethodologyStep,
});

// The sales methodology of each CRM pipeline (#2491). The step exists only
// behind the deal-state gate (Pro and up, the flag on): `useVisibleSteps` hides
// it otherwise, and a typed or bookmarked URL lands on the hub overview — but
// only on a verdict, never on an unanswered or failed read.
function AnalysisSetupSalesMethodologyStep() {
  const { t } = useTranslation(['analysisSetup']);
  const gate = useDealStateGate();

  if (gate.state === 'loading') {
    return (
      <div data-testid="sales-methodology-gate-loading">
        <SkeletonForm fields={3} />
      </div>
    );
  }
  if (gate.state === 'failed') {
    return (
      <div data-testid="sales-methodology-gate-error">
        <ErrorEmptyState
          title={t('analysisSetup:salesMethodology.gateErrorTitle')}
          description={t('analysisSetup:salesMethodology.gateErrorDescription')}
          onRetry={gate.canRetry ? gate.retry : undefined}
        />
      </div>
    );
  }
  if (!gate.enabled) return <Navigate to="/analysis-setup" replace />;

  return <SalesMethodologyStep />;
}
